const initialState ={
  refresh:0,
  external_crm_owners:{},
  api_keys:undefined
}

const reducer = (state = initialState, action) => {
  let newState= {...state};
  switch(action.type){
    case 'SWITCH_WORKSPACE':
      newState=initialState;
      break;
    case 'REQUEST_HUBSPOT_DISCONNECT_SUCCESS':
      window.location.reload();
      break;
    case 'REQUEST_INDEX_EXTERNAL_CRM_OWNERS_SUCCESS':
      if(newState.external_crm_owners[action.crm_login_id]==undefined){newState.external_crm_owners[action.crm_login_id]={}}
      for(let o of action.val){newState.external_crm_owners[action.crm_login_id][o.internal_id]=o;}
      newState.refresh=newState.refresh+1;
    break;
    case 'REQUEST_INDEX_HUBSPOT_CALL_DISPOSITIONS_SUCCESS':
      newState.hubspot_call_dispositions={}
      for(let o of action.val){newState.hubspot_call_dispositions[o.id]=o.label;}
    break;
    case 'REQUEST_GET_GMAIL_ADDRESSES_SUCCESS':
      if(newState.gmail==undefined){newState.gmail={}}
      if(newState.gmail.addresses==undefined){newState.gmail.addresses=action.val;}
      newState.refresh=newState.refresh+1;
    break;
    case 'GMAIL_UNAUTHORISED':
      newState.gmail='unauthorised';
    break;
    case 'REQUEST_GET_GMAIL_SETUP_SUCCESS':
      if(newState.gmail==undefined){newState.gmail={}}
      newState.gmail=(action.val=='disconnected')?'disconnected':{...newState.gmail, ...action.val};
      newState.refresh=newState.refresh+1;
    break;
    case 'REQUEST_CREATE_SMTP_LOGIN_SUCCESS':
    case 'REQUEST_UPDATE_SMTP_LOGIN_SUCCESS':
      let new_smtps=[]; let done=false;
      for(let s of newState.gmail.smtp_logins){if(s.id==action.val.id){new_smtps.push(action.val); done=true;}else{new_smtps.push(s);}}
      if(done==false){new_smtps.push(action.val);}
      newState.gmail.smtp_logins=JSON.parse(JSON.stringify(new_smtps));
      newState.refresh=newState.refresh+1;
    break;
    case 'REQUEST_UPDATE_EMAIL_SETUP_SUCCESS':
      if(newState.gmail==undefined){newState.gmail={}}
      newState.gmail={...newState.gmail, ...action.val};
      newState.refresh=newState.refresh+1;
    break;
    case 'REQUEST_UPDATE_EMAIL_UNSUBSCRIBE_MESSAGE_SUCCESS':
      if(newState.gmail==undefined){newState.gmail={}}
      newState.gmail.unsubscribe_message=action.val;
      newState.refresh=newState.refresh+1;
    break;
    case 'REQUEST_DELETE_SMTP_LOGIN_SUCCESS':
      let new_del_smtps=[];
      for(let s of newState.gmail.smtp_logins){if(s.id!=action.val.id){new_del_smtps.push(s);}}
      newState.refresh=newState.refresh+1;
      newState.gmail.smtp_logins=JSON.parse(JSON.stringify(new_del_smtps));
    break;
    case 'REQUEST_EMAIL_CONNECT_SUCCESS':
      newState.gmail=action.val
      newState.refresh=newState.refresh+1;
    break;
    case 'REQUEST_GMAIL_DISCONNECT_SUCCESS':
      newState.gmail='disconnected';
      newState.refresh=newState.refresh+1;
    break;
    case 'REQUEST_READ_EMAIL_MESSAGE_SUCCESS':
      newState.refresh=newState.refresh+1;
    break;
    case 'REQUEST_GET_EMAIL_SIGNATURES_SUCCESS':
      if(newState.gmail!='disconnected'){
        if(newState.gmail==undefined){newState.gmail={}}
        newState.gmail.signatures=action.val;
        newState.refresh=newState.refresh+1;
      }
    break;
    case 'REQUEST_CREATE_EMAIL_ADDRESS_SUCCESS':
    case 'REQUEST_UPDATE_EMAIL_ADDRESS_SUCCESS':
      if(newState.gmail==undefined){newState.gmail={}}
      newState.gmail.addresses=action.val.addresses;
      newState.refresh+=1;
    break;
    case 'REQUEST_DELETE_EMAIL_ADDRESS_SUCCESS':
      if(newState.gmail==undefined){newState.gmail={}}
      if(newState.gmail.addresses==undefined){newState.gmail.addresses=[]}
      let new_sigss=[];
      for(let s of newState.gmail.addresses){if(s.id==action.val.id){}else{new_sigss.push(s);}}
      newState.gmail.addresses=new_sigss;
      newState.refresh+=1;
    break;
    case 'REQUEST_GET_WEBHOOKS_SUCCESS':
      newState.webhooks=action.val;
      newState.refresh=newState.refresh+1;
    break;
    case 'REQUEST_CREATE_WEBHOOKS_SUCCESS':
      if(newState.webhooks==undefined){newState.webhooks=[];}
      newState.webhooks.push(action.val);
      newState.refresh+=1;
    break;
    case 'REQUEST_UPDATE_WEBHOOKS_SUCCESS':
      if(newState.webhooks==undefined){newState.webhooks=[];}
      let new_webhooks=[];
      for(let x of newState.webhooks){if(x.id==action.val.id){new_webhooks.push(action.val)}else{new_webhooks.push(x);}}
      newState.webhooks=new_webhooks;
      newState.refresh+=1;
    break;
    case 'REQUEST_DELETE_WEBHOOKS_SUCCESS':
      if(newState.webhooks==undefined){newState.webhooks=[];}
      let neww_webhooks=[];
      for(let x of newState.webhooks){if(x.id==action.val.id){}else{neww_webhooks.push(x);}}
      newState.webhooks=neww_webhooks;
      newState.refresh+=1;
    break;          
    case 'REQUEST_UPDATE_EMAIL_ENRICHMENT_API_KEYS_SUCCESS':
    case 'REQUEST_GET_EMAIL_ENRICHMENT_API_KEYS_SUCCESS':
      newState.email_enrichment=action.val;
      newState.refresh+=1;
    break;
    case 'REQUEST_CREATE_MARKETING_DOMAIN_SUCCESS':
      console.log(action.val);
      newState.refresh+=1;
    break;
    case 'REQUEST_INDEX_API_KEYS_SUCCESS':
      if(newState.api_keys==undefined){newState.api_keys={}}
      for(let av of action.val){newState.api_keys[av.id]=av;}
      newState.refresh+=1;
    break;
    case 'REQUEST_RESET_API_KEY':
      newState.new_api_key_id=undefined;
      console.log('HERE RESET');
    break;
    case 'REQUEST_CREATE_API_KEY_SUCCESS':
      newState.new_api_key_id=action.val.id;
    case 'REQUEST_UPDATE_API_KEY_SUCCESS':
      if(newState.api_keys==undefined){newState.api_keys={}}
      newState.api_keys[action.val.id]=action.val
      newState.refresh+=1;
    break;
    case 'REQUEST_DELETE_API_KEY_SUCCESS':
      if(newState.api_keys!=undefined && newState.api_keys[action.val.id]!=undefined){
        delete newState.api_keys[action.val.id];
      }
      newState.refresh+=1;
    break;
  }
  return newState;
}

export default reducer;
